import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ChartCardProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
  action?: ReactNode;
  minHeight?: number;
}

export function ChartCard({
  title,
  description,
  children,
  className,
  action,
  minHeight = 300,
}: ChartCardProps) {
  return (
    <div className={cn("card", className)}>
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          {description && (
            <p className="text-sm text-gray-500 mt-1">{description}</p>
          )}
        </div>
        {action}
      </div>
      <div style={{ minHeight }}>{children}</div>
    </div>
  );
}
